import { render, staticRenderFns } from "./WorkbenchStatisticalValuation.vue?vue&type=template&id=7620aeee&scoped=true&"
import script from "./WorkbenchStatisticalValuation.vue?vue&type=script&lang=js&"
export * from "./WorkbenchStatisticalValuation.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchStatisticalValuation.vue?vue&type=style&index=0&id=7620aeee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620aeee",
  null
  
)

export default component.exports